module.exports = __webpack_public_path__ + "img/Thanks.67a724f8.png";